export default __webpack_public_path__ + "static/media/check-blue.14145ab3.svg";